// import axios from 'axios'
import store from '../../store'
// import * as SRSFunc from './SRSFunctions'; 2025-08-13 jazz
import { SRSDefaults } from './SRSFunctions';

export class BasicSpecs{
    #Url;
    #axios;
    #UserBasicSpecsItems
    #MasterBasicSpecsItems
   
    constructor (url, axios) {
        this.#Url = url;
        this.#axios = axios;
        this.#UserBasicSpecsItems = store.state.UserInterface.BasicSpecs;
        //this.#MasterBasicSpecsItems = store.state.Master.BasicSpecs;
    }

    //********** GETTERS **********
    get UserBasicSpecsItems(){
        return this.#UserBasicSpecsItems;
    }

    async getMasterItems(){
        //let kihonItems = await SRSFunc.SRSDefaults.filteredItems((await axios.get(this.#Url)).data)

        const houseTypes = store.state.Master.HouseTypes;
        const selectedHouseType = houseTypes.find(item => item.HouseType == store.state.PlanInfo.HouseType);
        const typeCd = selectedHouseType?.TYPE_CD || null;

        // let kihonItems = await SRSFunc.SRSDefaults.filteredItems((await axios.get(this.#Url.replace("###", typeCd))).data)
        let kihonItems = await SRSDefaults.filteredItems((await this.#axios.get(this.#Url.replace("###", typeCd))).data) //2025-08-13 jazz
        
        return kihonItems;
    }
 
    ImportMasterDataToStore = async () =>{
        try{
            const response  = await this.#axios.get(this.#Url)
            //await SRSFunc.SRSDefaults.toggleLoading(true, 'updating BasicSpecs master, please wait...')
            //store.dispatch('BasicSpecs', response.data)
        }catch(e){
            console.log(e)
        }
    }

    ImportUserDataToStore = async (progressBar = null, basicSpecsItems = null) =>{
        if(progressBar){
            await progressBar.increment()
        }

        if(!basicSpecsItems){
            const houseTypes = store.state.Master.HouseTypes;
            const selectedHouseType = houseTypes.find(item => item.HouseType == store.state.PlanInfo.HouseType);
            const typeCd = selectedHouseType?.TYPE_CD || null;

            // basicSpecsItems = await SRSFunc.SRSDefaults.filteredItems((await axios.get(this.#Url.replace("###", typeCd))).data) //2025-08-13 jazz
            basicSpecsItems = await SRSDefaults.filteredItems((await this.#axios.get(this.#Url.replace("###", typeCd))).data)
        }

        if(progressBar){
            await progressBar.increment()
        }    

        try{
            // await SRSFunc.SRSDefaults.filteredUserInterface(basicSpecsItems,'UserBasicSpecs') 2025-08-13 jazz
            await SRSDefaults.filteredUserInterface(basicSpecsItems,'UserBasicSpecs')

            if(progressBar){
                await progressBar.increment()
            }
        }finally{
            basicSpecsItems = null
        }
    }
}